import React, { useState } from "react"
import clsx from "clsx"

import { Button } from "components"

import Post from "./_Post"
import PseudoBackground from "./_PseudoBackground"

function Feed({ category }) {
  const [page, setPage] = useState(1)

  const PAGE_SIZE = category?.slug === "/" ? 8 : 4

  return (
    <section className="relative wrapper">
      <PseudoBackground category={category} />
      <div className="relative pb-24 space-y-14">
        <ul className="default-grid gap-y-8">
          {category?.talking_shop_post
            .sort((a, b) => {
              return a?.date > b?.date ? -1 : 1
            })
            ?.slice(0, page * PAGE_SIZE)
            ?.map(({ category, slug, ...rest }, i) => (
              <li
                className={clsx(
                  "col-span-full",
                  category?.slug === "/"
                    ? "md:col-span-6 lg:col-span-4 xl:col-span-3"
                    : "sm:col-span-6"
                )}
                key={`post-${i}`}
              >
                <Post
                  {...rest}
                  href={`/news/${
                    category?.slug === "/" ? "" : category?.slug + "/"
                  }${slug}/`}
                  category={category}
                />
              </li>
            ))}
        </ul>
        {page * PAGE_SIZE < category?.talking_shop_post?.length && (
          <div className="flex justify-center">
            <Button
              label={`More ${category.name.toLowerCase()}`}
              appearance="primary"
              size="large"
              onClick={() => {
                setPage(page + 1)
              }}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default Feed
